exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._23UP-NNWNniBl8L-UcN7n_ .form-control{border-color:dycolor-internal(!input-bottom-border,@theme-white);color:dycolor-internal(!input-text,@theme-white)}._23UP-NNWNniBl8L-UcN7n_ .form-group input::-webkit-input-placeholder{color:dycolor-internal(!input-placeholder,@theme-grey)}._23UP-NNWNniBl8L-UcN7n_ .form-group input:-moz-placeholder{color:dycolor-internal(!input-placeholder,@theme-grey)}._23UP-NNWNniBl8L-UcN7n_ .form-group input::-moz-placeholder{color:dycolor-internal(!input-placeholder,@theme-grey)}._23UP-NNWNniBl8L-UcN7n_ .form-group input:-ms-input-placeholder{color:dycolor-internal(!input-placeholder,@theme-grey)}._23UP-NNWNniBl8L-UcN7n_ .custom-control-input:checked ~ .custom-control-indicator{background-color:dycolor-internal(!checkbox-active,@secondary)}._23UP-NNWNniBl8L-UcN7n_ .forgotpassword{color:dycolor-internal(!forgot-password,@theme-white)}\n", ""]);

// exports
exports.locals = {
	"root": "_23UP-NNWNniBl8L-UcN7n_"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/gotu-vue-common/src/components/login/email/Email.scss
// module id = 915
// module chunks = 1